import { queryClient } from '@/lib/query-client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Remove loading placeholder when React app is ready
const loadingPlaceholder = document.getElementById('vct-loading-placeholder');
if (loadingPlaceholder) {
  loadingPlaceholder.remove();
  console.log('[VCT] Loading placeholder removed');
}

ReactDOM.createRoot(document.getElementById('vct-app')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>
);
